<template>
  <div
    v-click-outside="hideMenu"
    class="spire-action-menu"
    :class="`spire-action-menu__trigger--${position}`"
  >
    <spire-button
      @click="toggleShowMenu"
      icon-left="fa-gear"
      :icon-right="iconRight"
      :variant="triggerVariant"
      :aria-label="triggerAriaLabel"
      :sizing="sizing"
      aria-haspopup="true"
      :area-expanded="showMenu"
      class="m-0"
      :class="`spire-action-menu__trigger--${position}`"
    />
    <ul v-show="showMenu" class="spire-action-menu__list">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SpireActionMenu",
  props: {
    targetName: {
      type: String,
      default: "Object",
    },
    position: {
      type: String,
      default: "right",
      validator(value) {
        return ["left", "right", "center"].includes(value);
      },
    },
    sizing: {
      type: String,
      default: "default",
      validator(value) {
        return ["default", "small"].includes(value);
      },
    },
    triggerVariant: {
      type: String,
      default: "secondary",
      required: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    iconRight() {
      return this.showMenu ? "fa-caret-up" : "fa-caret-down";
    },
    triggerAriaLabel() {
      const verb = this.showMenu ? "Hide" : "Show";
      return `${verb} ${this.targetName} actions`;
    },
  },
  methods: {
    toggleShowMenu() {
      this.showMenu = !this.showMenu;
      let tab = document.querySelector(".page-container__tab--active");
      if (this.showMenu && tab) {
        tab.classList.add("pb-12");
      } else if (tab) {
        tab.classList.remove("pb-12");
      }
    },
    hideMenu() {
      this.showMenu = false;
    },
  },
};
</script>
